var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('filters-list-section',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('filter-list-item',{staticClass:"single-list-filter_padding-item"},[_vm._t("default")],2)]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }